import z from 'zod'

import { LOCALE } from '@/legacy-src/constants/locale.constants'

import { StrapiContentModel, type StrapiCustomMenu } from '@/src/domains/strapi/constants'
import { getCacheTag } from '@/src/domains/strapi/services/getCacheTag'
import type { StrapiQueryParams } from '@/src/domains/strapi/types'
import { fetchStrapi } from '@/src/domains/strapi/utils/fetchStrapi'

export const getStrapiMenuSlugTag = (slug: string) => getCacheTag(slug, StrapiContentModel.CUSTOM_MENU)

export interface FetchStrapiMenu<Schema extends z.ZodObject<z.ZodRawShape> = z.ZodObject<z.ZodRawShape>> {
  slug: `${StrapiCustomMenu}`
  schema: Schema
  query?: StrapiQueryParams
}

export async function fetchStrapiMenu<Schema extends z.ZodObject<z.ZodRawShape>>({
  slug,
  query,
  schema,
}: FetchStrapiMenu<Schema>) {
  const fullSlug = `${slug}-${LOCALE}`

  const menus = await fetchStrapi({
    contentType: 'custom-menus',
    query: {
      ...query,
      filters: {
        ...query?.filters,
        slug: fullSlug,
      },
    },
    schema: z.array(schema),
    cache: {
      tags: [getStrapiMenuSlugTag(fullSlug)],
    },
  })

  return menus.at(0)
}
